var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"object-link",attrs:{"to":_vm.$objectViewRoute(_vm.object)}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$objectDenomination(_vm.object))+" ")]}),_c('i',{staticClass:"fas fa-external-link-alt"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }